<template>
  <v-main>
    <div
      v-if="valorImagen === false"
      class="d-flex flex-column justify-space-between align-center"
    >
      <v-img
        :src="imgLogo"
        max-width="320"
      />
    </div>
    <router-view />
    <dashboard-core-footer />
  </v-main>
</template>

<script>
  export default {
    name: 'DashboardCoreView',

    components: {
      DashboardCoreFooter: () => import('./Footer'),
    },
    data: () => ({
      valorImagen: false,
      url: '',
      imgLogo: '',
    }),
    mounted () {
      this.imgLogo = localStorage.getItem('imgLogo')
      // this.url = localStorage.getItem('urlSitio') + '/assets/logo.jpeg'
      this.valorImagen = this.$store.state.valorEnviado
    },
    methods: {
      irInicio () {
        this.$router.replace('/login')
      },
    },
  }
</script>
